<template>
  <section id="company">
    <v-layout column wrap class="purple lighten-5" align-center>
      <v-flex xs12 sm4 class="my-3 pa-5">
        <div class="text-xs-center">
          <h2 class="headline">会社概要</h2>
          <span class="subheading purple--text">
            CompanyInfo
          </span>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center class="purple lighten-5">
      <v-flex xs2 md1 class="outline item white--text">
        <div class="text-md-right">会社名</div>
      </v-flex>
      <v-flex xs6 md3 outline>
        <div class="text-md-left">株式会社happiness</div>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center class="purple lighten-5">
      <v-flex xs2 md1 class="outline item white--text">
        <div class="text-md-right">設立</div>
      </v-flex>
      <v-flex xs6 md3 outline>
        <div class="text-md-left">平成20年4月1日</div>
      </v-flex>
    </v-layout>
    <!-- <v-layout row wrap justify-center class="purple lighten-5">
      <v-flex xs2 md1 class="outline item white--text">
        <div class="text-md-right">所在地</div>
      </v-flex>
      <v-flex xs6 md3 outline>
        <div class="text-md-left">
          東京都千代田区四番町2番地4 ブランズ四番町1505号
        </div>
      </v-flex>
    </v-layout> -->
    <v-layout row wrap justify-center class="purple lighten-5 pb-5">
      <v-flex xs2 md1 class="outline item white--text">
        <div class="text-md-right">資本金</div>
      </v-flex>
      <v-flex xs6 md3 outline>
        <div class="text-md-left">300万円</div>
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
export default {};
</script>

<style>
.item {
  background-color: #d4a9db;
}
.outline {
  padding: 1rem;
  margin: 3px;
}
</style>
